import React, { useEffect, useRef, useState } from 'react';
import { useInView, useReducedMotion } from 'motion/react';

const GLYPHS = '01<>/\\[]{}=+*#_-';

/*
 * Text that decodes into place: each character cycles through glyphs, then resolves,
 * left to right (Igloo Inc's labels). Plays when scrolled into view, and again whenever
 * `play` changes. Screen readers get the final text from a visually hidden copy.
 */
const ScrambleText = ({ text, as: Tag = 'span', duration = 700, play, className }) => {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const [output, setOutput] = useState(text);

  useEffect(() => {
    if (reduced || !inView) {
      setOutput(text);
      return undefined;
    }
    let frame = 0;
    const start = performance.now();
    const chars = Array.from(text);
    const tick = now => {
      const t = Math.min(1, (now - start) / duration);
      setOutput(
        chars
          .map((char, i) => {
            if (char === ' ' || t >= (i + 1) / chars.length) return char;
            return t > i / chars.length - 0.35 ? GLYPHS[Math.floor(Math.random() * GLYPHS.length)] : char === ' ' ? ' ' : ' ';
          })
          .join('')
      );
      if (t < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [text, duration, play, inView, reduced]);

  return (
    <Tag ref={ref} className={className}>
      <span className="sr-only">{text}</span>
      <span aria-hidden="true">{output}</span>
    </Tag>
  );
};

export default ScrambleText;
